import { grid1Categories } from '@/mocks/categories';

export default function CategoryGrid1() {
  return (
    <section className="relative py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <p className="text-xs md:text-sm text-foreground-500 font-label tracking-widest uppercase mb-3">
            Curated for You
          </p>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            Trending<br />
            <span className="italic font-medium text-primary-500">Categories</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {grid1Categories.map((cat, idx) => {
            const bgColors = [
              'bg-[#f5e6d8]',
              'bg-[#dce8dc]',
              'bg-[#e8e4df]',
              'bg-[#e8dcc8]',
            ];
            return (
              <a
                key={cat.seq}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="group block rounded-2xl overflow-hidden bg-white hover:scale-[1.02] transition-transform duration-300 cursor-pointer"
              >
                <div className={`h-[280px] md:h-[340px] ${bgColors[idx]} flex items-center justify-center p-8`}>
                  <img
                    src={cat.imageUrl}
                    alt={`CSSBuy ${cat.name} Spreadsheet`}
                    title={`CSSBuy ${cat.name} Spreadsheet`}
                    className="w-full h-full object-cover object-center rounded-xl"
                    loading="lazy"
                  />
                </div>
                <div className="px-5 py-4">
                  <h3 className="font-heading text-lg font-semibold text-foreground-900">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1 border-b border-foreground-200 pb-1 inline-block">
                    Browse collection &rarr;
                  </p>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}